<template>
  <div class="app-container">
    <div class="outer">
      <nbyx-tabs @changeOriginType="changeOriginType"
      />
      <el-tabs
        v-model="activeName"
        type="border-card"
      >
        <el-tab-pane
          label="待发货"
          name="1"
        >
          <OrderList ref="orderListRef" v-if="activeName === '1'" :originType="originType" />
        </el-tab-pane>

        <el-tab-pane
          label="导入发货"
          name="2"
        >
          <import-order ref="importOrderRef" v-if="activeName === '2'" :originType="originType" />
        </el-tab-pane>

        <el-tab-pane
          label="已发货"
          name="3"
        >
          <already-list ref="alreadyListRef" v-if="activeName === '3'" :originType="originType" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import OrderList from './orderList.vue';
import ImportOrder from './order-import.vue';
import alreadyList from './already-list.vue';
import NbyxTabs from '@/components/order/nbyx-tabs.vue';

export default {
  name: '',
  components: {
    OrderList,
    ImportOrder,
    alreadyList,
    NbyxTabs
  },
  props: {},
  data() {
    return {
      originType: null,
      activeName: '1',
      orderListRef: null,
      importOrderRef: null,
      alreadyListRef: null,
    };
  },
  methods: {
    changeOriginType(originType) {
      console.log('changeOriginType', originType);
      console.log('this.activeName', this.activeName);
      this.originType = originType;
      this.$nextTick(() => {
        if (this.activeName === '1') {
          this.$refs.orderListRef.didChangeOriginType(originType);
        } else if (this.activeName === '2') {
          this.$refs.importOrderRef.didChangeOriginType(originType);
        } else if (this.activeName === '3') {
          this.$refs.alreadyListRef.didChangeOriginType(originType);
        }
      });
      // if (this.activeName === '1') {
      //   this.$refs.orderListRef.didChangeOriginType(originType);
      // } else if (this.activeName === '2') {
      //   this.$refs.importOrderRef.didChangeOriginType(originType);
      // } else if (this.activeName === '3') {
      //   this.$refs.alreadyListRef.didChangeOriginType(originType);
      // }

    },
  },
};
</script>
